import { EmployeesService, IEmployee } from '../../services/employees.service';
import * as moment from 'moment';
import * as _ from 'lodash';
class DashboardBirthdayController {
    private employees: IEmployee[];
    constructor(private EmployeesService: EmployeesService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getEmployees();
    }

    public getEmployees = () => {
        this.EmployeesService.getEmployeesByStatus().then((employees) => {
            this.employees = employees;
            var now = moment();
            var currentYear = moment().year();
            this.employees.forEach(employee => {
                var b = moment(employee.birthday).year(currentYear);
                if(moment().isAfter(b)) {
                    employee.birthday = moment(employee.birthday).year(currentYear + 1).format('YYYY-MM-DD');
                } else {
                    employee.birthday = moment(employee.birthday).year(currentYear).format('YYYY-MM-DD');
                }
            });
            this.employees = _.remove(this.employees, function(value, index) {
                if(value.displayName){
                    return value.displayName.length;
                }
            });
            this.employees = _.orderBy(this.employees, ['birthday'], ['asc']);
        })
    }
}

export const dashboardBirthdayComponent = {
    controller: DashboardBirthdayController,
    template: require('./dashboard.birthday.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.birthday.component.ts